/**
 * Navigation and page updates
 */
const PAGE_VIEW_TYPES = {
  mobilePayment: "mobile",
  web: "web",
  therapistClient: "therapist_client",
  partnerCheckout: "partner_checkout",
  partnerOnboarding: "partner_onboarding",
  referral: "referral",
};

const PAGE_PATH = {
  parent: "parent",
  myself: "myself",
};

// Every page type in the app
const PAGE_TYPES = {
  // Onboarding
  input: "input_type",
  loading: "loading_type",
  successType: "success_type",
  singleSelect: "single_select_type",
  avatarSelect: "avatar_select_type",
  multiSelect: "multi_select_type",
  multiPillSelect: "multi_pill_select_type",
  carosel: "carosel_type",
  category: "category_type",
  step: "step_type",
  summary: "summary_type",
  details: "details_type",
  info: "info_type",
  getStarted: "get_started_type",
  letUsKnow: "let_us_know_type",
  ethnicity: "ethnicity_type",

  //Allianz
  paymentSetupAccountAllianz: "web_payment_setup_account_allianz_type",
  afqTypeformAllianz: "aqf_typeform_allianz_type",
  infoAllianz: "info_allianz_type",

  // Web payment
  payment: "web_payment_type",
  paymentDownload: "web_payment_download_type",
  paymentSuccess: "web_payment_success_type",
  paymentDelivery: "web_payment_delivery_type",
  paymentPlan: "web_payment_select_plan_type",
  paymentSetupAccount: "web_payment_setup_account_type",

  // Mobile payment
  mobilePayment: "mobile_payment_type",

  // Therapist-client payment
  therapistClientPayment: "therapist_client_payment_type",
  therapistClientPaymentSuccess: "therapist_client_payment_success_type",
  therapistClientPaymentDownload: "therapist_client_payment_download_type",

  // Partner paywall
  partnerPaymentSuccess: "partner_payment_success_type",
  partnerPaymentDownload: "partner_payment_download_type",
  partnerPaymentPlan: "partner_payment_plan_type",

  //Partner onboarding
  partnerOnboardingSetupAccount: "partner_payment_setup_account_type",
  partnerOnboardingPlan: "partner_onboarding_payment_select_plan_type",
  partnerOnboardingDelivery: "partner_onboarding_payment_delivery_type",
};

const PAGE_KEYS = {
  id: "id",
  type: "type",
  data: "data",
  componentType: "component_type",
  defaultProgression: "default_progression",
  targetField: "target_field",
  targetState: "target_state",
  targetPages: "target_pages",
  order: "order",
  moduleName: "module_name",
  title: "title",
  backwardsNavEnabled: "backwards_navigation_enabled",
  theme: "theme",
  headerArch: "has_header_arch",
};

const PAGE_THEMES = {
  WARM: "warm",
  COLD: "cold",
  LIGHT: "light",
  MELLOW: "mellow",
};

export { PAGE_VIEW_TYPES, PAGE_TYPES, PAGE_KEYS, PAGE_THEMES, PAGE_PATH };
